<template>
  <div>
    <slot
      v-if="!subscribed"
      name="form"
      :subscription="subscription"
      :subscribe="subscribe"
      :captcha="captcha"
      :captchaVerified="captchaVerified"
      :resetCaptcha="resetCaptcha"
      :errors="errors"
    />
    <slot v-else name="thank-you" />
  </div>
</template>

<script>
import axios from '../../common/http/axios';
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';

export default {
  props: {
    url: { required: true, type: String }
  },

  data() {
    return {
      subscribed: false,
      errors: {
        email: null,
        captcha: null
      },
      subscription: {
        email: '',
        captcha_token: ''
      }
    };
  },

  computed: {
    captcha() {
      return VueHcaptcha;
    }
  },

  methods: {
    captchaVerified(token) {
      this.subscription.captcha_token = token;
    },

    resetCaptcha() {
      this.subscription.captcha_token = null;
    },

    async subscribe() {
      if (this.subscribed) return;

      try {
        await axios.post(this.url, this.subscription);

        this.subscribed = true;
      } catch (e) {
        this.errors.email = e.response.data.email;
        this.errors.captcha = e.response.data.captcha;
      }
    }
  }
};
</script>

<style lang="scss">
.subscribe-submit:disabled {
  @apply bg-opacity-50 bg-light-grey;
  @apply cursor-not-allowed;
}
</style>
